"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _reactRouterDom = require("react-router-dom");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _ProductsAndPlansNavIds = require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _FeatureTile = _interopRequireDefault(require("./FeatureTile"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  max-width: 840px;\n  padding: 0 20px;\n  z-index: 2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: center;\n\n  @media (max-width: ", "px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border-radius: 3px;\n  max-width: 816px;\n  text-align: center;\n  padding: 25px;\n  margin: 16px 0;\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AdvancedCrmCta = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__AdvancedCrmCta",
  componentId: "bru6k-0"
})(_templateObject(), _colors.GYPSUM);

var FeatureRow = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__FeatureRow",
  componentId: "bru6k-1"
})(_templateObject2(), _Breakpoints.FEATURES_SECTION - 1);

var FeaturesSectionContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesSection__FeaturesSectionContainer",
  componentId: "bru6k-2"
})(_templateObject3());

function FeaturesSection(_ref) {
  var onViewMore = _ref.onViewMore,
      history = _ref.history;
  return _react.default.createElement(FeaturesSectionContainer, null, _react.default.createElement(FeatureRow, null, _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-crmfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeCrmTools"
    }),
    hubType: Hubs.HUB_SALES,
    features: _ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_CRM].features,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_CRM
  }), _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-marketingfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeMarketingTools"
    }),
    features: _ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_MARKETING_FREE].features,
    hubType: Hubs.HUB_MARKETING,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_MARKETING_FREE
  })), _react.default.createElement(AdvancedCrmCta, null, _react.default.createElement("div", {
    style: {
      maxWidth: '550px'
    }
  }, _react.default.createElement("div", null, _react.default.createElement("b", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.interested"
  }))), _react.default.createElement(_FormattedJSXMessage.default, {
    options: {
      onClick: function onClick() {
        history.push((0, _urls.getProductTabUrl)(_ProductsAndPlansNavIds.SALES));
        window.scrollTo(0, 0);
      },
      gaClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesplans')
    },
    elements: {
      UILink: _UILink.default
    },
    message: "pricingPage.pages.crm.learn_jsx"
  }))), _react.default.createElement(FeatureRow, null, _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-salesfeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeSalesTools"
    }),
    features: _ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_SALES_FREE].features,
    hubType: Hubs.HUB_SALES,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_SALES_FREE
  }), _react.default.createElement(_FeatureTile.default, {
    modalViewClassName: (0, _publicPageUrls.getGAClassName)('crm-pricing-servicefeatures'),
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeServiceTools"
    }),
    features: _ImmutableMerchandiseIdMap.default[_MerchandiseIds.PRODUCT_SERVICE_FREE].features,
    hubType: Hubs.HUB_SERVICE,
    onViewMore: onViewMore,
    merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_FREE
  })));
}

var _default = (0, _reactRouterDom.withRouter)(FeaturesSection);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FeaturesSection.js
// module id = 579
// module chunks = 5 6